<template>
  <div>
    <div id="modal-pyramid" class="modal fade" aria-hidden="true" ref="editPyramid">
      <div class="modal-dialog">
        <div class="">
          <div class="modal-body ibox">
            <div class="col-lg-12">
              <div class="ibox ">
                <div class="ibox-title">
                  <h5>Edit Tier</h5>
                  <div class="ibox-tools">
                    <a class="close-modal" data-dismiss="modal">
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                </div>
                <div class="ibox-content">
                  <div class="row">
                    <div class="row col-lg-12">
                      <div class="col-lg-12">
                        <div class="col-lg-4">
                          <label for="iRDFrom">RD:</label>
                        </div>
                        <div class="col-lg-8">
                          <input type="number" min="0" name="RDFrom" id="iRDFrom" placeholder="0" class="col-lg-6" ref="rdFrom" :value="tierData.filters.rdFrom || ''">
                          <input type="number" min="0" name="RDTo" id="iRDTo" placeholder="∞" class="col-lg-6" ref="rdTo" :value="tierData.filters.rdTo || ''">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="col-lg-4">
                          <label for="iTFFrom">TF:</label>
                        </div>
                        <div class="col-lg-8">
                          <input type="number" min="0" name="TFFrom" id="iTFFrom" placeholder="0" class="col-lg-6" ref="tfFrom" :value="tierData.filters.tfFrom || ''">
                          <input type="number" min="0" name="TFTo" id="iTFTo" placeholder="∞" class="col-lg-6" ref="tfTo" :value="tierData.filters.tfTo || ''">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="col-lg-4"><label for="iDAFrom">DA:</label></div>
                        <div class="col-lg-8">
                          <input type="number" min="0" name="DAFrom" id="iDAFrom" placeholder="0" class="col-lg-6" ref="daFrom" :value="tierData.filters.daFrom || ''">
                          <input type="number" min="0" name="DATo" id="iDATo" placeholder="∞" class="col-lg-6" ref="daTo" :value="tierData.filters.daTo || ''">
                        </div>
                      </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="row m-t-md">
                              <div class="search col-lg-12">
                                <div class="col-lg-4">
                                  <div class="col-lg-4">
                                    <label for="iNum">Number:</label>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <input type="number" name="number" id="iNum" ref="iNum" min="0" class="col-lg-4" :value="tierData.num || 0" @keydown.enter="updateTier">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <button class="btn btn-sm btn-default label-primary" type="submit" @click="updateTier">Save</button>
                      <input type="hidden" name="id" ref="id" :value="tierData.id || ''">
                      <input type="hidden" name="pyramid" :value="pyramid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../../main'

export default {
  name: 'PyramidModal',
  data () {
    return {
      pyramid: this.$route.params.pyramidId
    }
  },
  props: ['tierData'],
  methods: {
    updateTier () {
      let data = this.$refs
      axios.post('link-pyramid/' + this.$route.params.pyramidId + '/tier', {
        id: data.id.value,
        num: data.iNum.value,
        filters: {
          daFrom: data.daFrom.value,
          daTo: data.daTo.value,
          rdFrom: data.rdFrom.value,
          rdTo: data.rdTo.value,
          tfFrom: data.tfFrom.value,
          tfTo: data.tfTo.value
        }
      })
        .then(response => {
          eventBus.$emit('tierUpdate')
          $('#modal-pyramid').modal('hide')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Apps/link-pyramid/TierModal.vue